import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	edit__file__delete: 'mw/file/delete',
	edit__file__upload: 'mw/file/upload',
	edit__file__report__list: 'mw/file/report/list',
	edit__file__report__delete: 'mw/file/report/delete',
	edit__file__report__cancel: 'mw/file/report/cancel',
};

export const fileApi = createApi({
	reducerPath: 'mw/fileApi',
	tagTypes: Object.values(tags),
	endpoints: (builder) => ({
		editFileDelete: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/file/delete',
				body,
			}),
			providesTags: [tags.edit__file__delete],
		}),
		editFileUpload: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/file/upload',
				body,
				file: true,
			}),
			providesTags: [tags.edit__file__upload],
		}),
		fileReportList: builder.query({
			query: (body) => ({
				method: 'GET',
				url: `/mw/file/report/list?${qs.stringify(body)}`,
			}),
			serializeQueryArgs: ({ endpointName }) => {
				return endpointName;
			},
			merge: (currentCache, newItems) => {
				if (currentCache?.result && !Array.isArray(currentCache.result)) {
					currentCache.result = {
						...currentCache.result,
						...newItems.result,
					};
				} else {
					currentCache = newItems;
				}

				return currentCache;
			},
			forceRefetch({ currentArg, previousArg }) {
				return currentArg !== previousArg;
			},
			transformResponse: (response) => {
				return {
					...response,
					result: Object.values(response.result || {}) || [],
				};
			},
			providesTags: [tags.edit__file__report__list],
		}),
		fileReportDelete: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/file/report/delete',
				body,
			}),
			invalidatesTags: [tags.edit__file__report__list],
		}),
		fileReportCancel: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/file/report/cancel',
				body,
			}),
			invalidatesTags: [tags.edit__file__report__list],
		}),
	}),
});

export const {
	editFileDelete,
	editFileUpload,
	fileReportList,
	fileReportDelete,
	fileReportCancel,
} = fileApi.endpoints;

export default fileApi;
